import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ClinicContentBlock } from '../../../data/models/ClinicContentBlock';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { CONSTANTS } from '../../../helper/constants';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-text-block-dialog',
  imports: [ReactiveFormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule],
  templateUrl: './text-block-dialog.component.html',
  styleUrl: './text-block-dialog.component.scss'
})
export class TextBlockDialogComponent implements OnInit {
  form!: FormGroup
  isEdit: boolean
  private isClosing = false

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<TextBlockDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { block?: ClinicContentBlock }
  ) {
    this.isEdit = !!data?.block
  }

  ngOnInit(): void {
    this.dialogRef.backdropClick().subscribe(() => this.tryClose(null))
    this.dialogRef.keydownEvents().subscribe(e => {
      if (e.key === 'Escape') {
        e.preventDefault()
        this.tryClose(null)
      }
    })

    this.form = this.fb.group({
      title: [this.data?.block?.title || '', [Validators.maxLength(CONSTANTS.maxInput)]],
      body_text: [this.data?.block?.body_text || '', [Validators.required, Validators.maxLength(CONSTANTS.maxInput)]]
    })
  }

  async tryClose(result: string | null): Promise<void> {
    if (this.isClosing) return
    if (this.form.dirty) {
      this.isClosing = true
      try {
        const confirmed = await this.confirmDiscard()
        if (!confirmed) return
      } finally {
        this.isClosing = false
      }
    }
    this.dialogRef.close(result)
  }

  private async confirmDiscard(): Promise<boolean> {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Änderungen verwerfen',
        message: 'Du hast ungespeicherte Änderungen. Wenn du den Dialog verlässt, gehen diese verloren.',
        confirmText: 'Verwerfen'
      }
    })
    return !!(await firstValueFrom(ref.afterClosed()))
  }

  save(): void {
    if (this.form.invalid) return
    this.dialogRef.close(this.form.value)
  }
}
